<div class="sheet" role="dialog" aria-modal="true">
    <div class="sheet-head">
        <h2>Konfiguration senden?</h2>
        <button class="x" (click)="close()" aria-label="Schließen">×</button>
    </div>
    <p class="lead">Vergleich mit der Konfiguration im Gateway. Gesendet werden nur diese Änderungen, alles andere
        bleibt unverändert.</p>

    <div class="note err" role="alert" *ngIf="errors.length">
        <b>Senden nicht möglich</b>
        <ul>
            <li *ngFor="let e of errors">{{ e }}</li>
        </ul>
    </div>

    <div class="note info" *ngIf="!changes.length">Keine Änderungen zur Konfiguration im Gateway.</div>

    <section class="diff" *ngFor="let c of changes">
        <h3>
            <span>Adresse {{ c.address }} · {{ c.typeLabel }}</span>
            <span class="chip new" *ngIf="c.kind === 'new'">neu</span>
            <span class="chip rem" *ngIf="c.kind === 'removed'">wird entfernt</span>
            <span class="chip chg" *ngIf="c.kind === 'changed'">geändert</span>
        </h3>
        <ul>
            <li *ngIf="c.kind === 'removed'">
                <span>Modul und seine Konfiguration werden im Gateway gelöscht</span><span></span>
            </li>
            <li *ngIf="c.kind === 'new' && !c.items.length"><span>Keine Einstellungen</span><span></span></li>
            <li *ngFor="let i of c.items">
                <span>{{ i.label }}<ng-container *ngIf="i.reset"> (Konfiguration wird zurückgesetzt)</ng-container></span>
                <span>
                    <ng-container *ngIf="i.from !== undefined"><del>{{ i.from }}</del> → </ng-container><ins>{{ i.to }}</ins>
                </span>
            </li>
        </ul>
    </section>

    <div class="note info">Nach dem Senden die Daten neu laden. Erst dann zeigt sich, ob das Gateway alle Module
        findet.
    </div>

    <div class="actions">
        <button class="btn" (click)="close()">Abbrechen</button>
        <button class="btn primary" [disabled]="errors.length" (click)="send()">Konfiguration senden</button>
    </div>
</div>
